export default "__VITE_ASSET__c2b3a5f0__$_?nuxt_component=async&nuxt_component_name=SvgoLogo__"